import { gql } from '@apollo/client'

export const PhaseFragment = gql`
  fragment PhaseFragment on Phase {
    key
    label
    shortLabel
    color
    disabled
  }
`
